<template>
  <div class="app-container">
    <basic-container>
      <el-form label-position="top" :rules="rules" ref="ruleForm" :model="form" size="medium">

        <el-form-item label="课件名称" prop="name">
          <el-col :span="12">
            <el-input v-model="form.name" :maxlength="200"></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="课件名称（英文）" prop="nameEn">
          <el-col :span="12">
            <el-input v-model="form.nameEn" :maxlength="200"></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="课件描述" prop="description">
          <el-col :span="12">
            <el-input type="textarea" v-model="form.description" maxlength="400" :rows="3" resize="none"></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="课件描述（英文）" prop="descriptionEn">
          <el-col :span="12">
            <el-input type="textarea" v-model="form.descriptionEn" maxlength="400" :rows="3" resize="none"></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="课件分组" prop="coursewareGroupId">
          <el-col :span="12">
            <el-select v-model="form.coursewareGroupId" placeholder="课件分组" clearable>
              <el-option
                v-for="item in coursewareGroups"
                :key="item.id"
                :label="item.groupName"
                :value="item.id">
              </el-option>
            </el-select>
          </el-col>
        </el-form-item>

        <el-form-item label="课件类型" prop="type">
          <el-col :span="12">
            <el-select v-model="form.type" placeholder="课件类型" @change="handleTypeChange" :disabled="isTypeSelectDisabled">
              <el-option
                v-for="item in coursewareTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-col>
        </el-form-item>

        <el-form-item :label="coursewareFileFormLabel" prop="coursewareUrl">
          <el-col :span="12">
            <template v-if="isEdit && form.coursewareUrl && !isRemoveUploadedCoursewareFile">
              <img v-if="form.type===COURSEWARE_FILE_TYPE_ENUM.VIDEO.value" width="14" class="right-space" src="data:image/svg+xml;base64,PHN2ZyB0PSIxNjY0NDE3MDQwMzAyIiBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjM1MDciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiI+PHBhdGggZD0iTTAgMG05My4wOTA5MDkgMGw4MzcuODE4MTgyIDBxOTMuMDkwOTA5IDAgOTMuMDkwOTA5IDkzLjA5MDkwOWwwIDgzNy44MTgxODJxMCA5My4wOTA5MDktOTMuMDkwOTA5IDkzLjA5MDkwOWwtODM3LjgxODE4MiAwcS05My4wOTA5MDkgMC05My4wOTA5MDktOTMuMDkwOTA5bDAtODM3LjgxODE4MnEwLTkzLjA5MDkwOSA5My4wOTA5MDktOTMuMDkwOTA5WiIgZmlsbD0iIzdDOEVFRSIgcC1pZD0iMzUwOCI+PC9wYXRoPjxwYXRoIGQ9Ik03MjcuNzczMDkxIDU1My44MjEwOTFsLTM0OC45NzQ1NDYgMjA5LjA5MzgxOEMzNTUuNDkwOTA5IDc3Ny4wNDE0NTUgMzI1LjgxODE4MiA3NjAuMDg3MjczIDMyNS44MTgxODIgNzMyLjU0NFYzMTQuMzMzMDkxYzAtMjYuODQ1MDkxIDI5LjY3MjcyNy00My43OTkyNzMgNTIuOTgwMzYzLTMwLjM3MDkwOWwzNDguOTc0NTQ2IDIwOS4wOTM4MThjMjIuNjA5NDU1IDE0LjEyNjU0NSAyMi42MDk0NTUgNDcuMzI1MDkxIDAgNjAuNzQxODE4eiIgZmlsbD0iI0ZGRkZGRiIgcC1pZD0iMzUwOSI+PC9wYXRoPjwvc3ZnPg==">
              <img v-if="form.type===COURSEWARE_FILE_TYPE_ENUM.PDF.value"  width="14" class="right-space" src="data:image/svg+xml;base64,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">
              <a class="c-primary right-space" :href="form.coursewareUrl" target="_blank">
                {{ form.type === COURSEWARE_FILE_TYPE_ENUM.PDF.value ? getPdfName(form.coursewareUrl) : '视频文件'}}
              </a>
              <i class="el-icon-close click" @click="handleRemoveUploadedFile(handleUploadCoursewareFileRemove)"></i>
            </template>
            <upload
              v-else
              :fileType="form.type"
              @onStart="handleUploadCoursewareFileStart"
              @onSuccess="handleUploadCoursewareFileSuccess"
              @onRemove="handleUploadCoursewareFileRemove" />
          </el-col>
        </el-form-item>
        <el-form-item :label="coursewareFileFormLabelEn" prop="coursewareUrlEn">
          <el-col :span="12">
            <template v-if="isEdit && form.coursewareUrlEn && !isRemoveUploadedCoursewareFileEn">
              <img v-if="form.type===COURSEWARE_FILE_TYPE_ENUM.VIDEO.value" width="14" class="right-space" src="data:image/svg+xml;base64,PHN2ZyB0PSIxNjY0NDE3MDQwMzAyIiBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjM1MDciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiI+PHBhdGggZD0iTTAgMG05My4wOTA5MDkgMGw4MzcuODE4MTgyIDBxOTMuMDkwOTA5IDAgOTMuMDkwOTA5IDkzLjA5MDkwOWwwIDgzNy44MTgxODJxMCA5My4wOTA5MDktOTMuMDkwOTA5IDkzLjA5MDkwOWwtODM3LjgxODE4MiAwcS05My4wOTA5MDkgMC05My4wOTA5MDktOTMuMDkwOTA5bDAtODM3LjgxODE4MnEwLTkzLjA5MDkwOSA5My4wOTA5MDktOTMuMDkwOTA5WiIgZmlsbD0iIzdDOEVFRSIgcC1pZD0iMzUwOCI+PC9wYXRoPjxwYXRoIGQ9Ik03MjcuNzczMDkxIDU1My44MjEwOTFsLTM0OC45NzQ1NDYgMjA5LjA5MzgxOEMzNTUuNDkwOTA5IDc3Ny4wNDE0NTUgMzI1LjgxODE4MiA3NjAuMDg3MjczIDMyNS44MTgxODIgNzMyLjU0NFYzMTQuMzMzMDkxYzAtMjYuODQ1MDkxIDI5LjY3MjcyNy00My43OTkyNzMgNTIuOTgwMzYzLTMwLjM3MDkwOWwzNDguOTc0NTQ2IDIwOS4wOTM4MThjMjIuNjA5NDU1IDE0LjEyNjU0NSAyMi42MDk0NTUgNDcuMzI1MDkxIDAgNjAuNzQxODE4eiIgZmlsbD0iI0ZGRkZGRiIgcC1pZD0iMzUwOSI+PC9wYXRoPjwvc3ZnPg==">
              <img v-if="form.type===COURSEWARE_FILE_TYPE_ENUM.PDF.value"  width="14" class="right-space" src="data:image/svg+xml;base64,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">
              <a class="c-primary right-space" :href="form.coursewareUrlEn" target="_blank">
                {{ form.type === COURSEWARE_FILE_TYPE_ENUM.PDF.value ? getPdfName(form.coursewareUrlEn) : '视频文件'}}
              </a>
              <i class="el-icon-close click" @click="handleRemoveUploadedFile(handleUploadCoursewareFileRemoveEn)"></i>
            </template>
            <upload
              v-else
              :fileType="form.type"
              @onStart="handleUploadCoursewareFileStartEn"
              @onSuccess="handleUploadCoursewareFileSuccessEn"
              @onRemove="handleUploadCoursewareFileRemoveEn" />
          </el-col>
        </el-form-item>

        <el-form-item prop="coverUrl" v-if="form.type===COURSEWARE_FILE_TYPE_ENUM.VIDEO.value">
          <template slot="label">
            视频封面 <span class="image-upload-tip">(推荐尺寸为750×320像素,支持jpg、jpeg、png格式)</span>
          </template>
          <el-col :span="12">
            <template v-if="isEdit && form.coverUrl">
              <img width="14" class="right-space" src="data:image/svg+xml;base64,PHN2ZyB0PSIxNjY0NTA4OTk3NTg0IiBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjM1MjEiIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiI+PHBhdGggZD0iTTAgMG05My4wOTA5MDkgMGw4MzcuODE4MTgyIDBxOTMuMDkwOTA5IDAgOTMuMDkwOTA5IDkzLjA5MDkwOWwwIDgzNy44MTgxODJxMCA5My4wOTA5MDktOTMuMDkwOTA5IDkzLjA5MDkwOWwtODM3LjgxODE4MiAwcS05My4wOTA5MDkgMC05My4wOTA5MDktOTMuMDkwOTA5bDAtODM3LjgxODE4MnEwLTkzLjA5MDkwOSA5My4wOTA5MDktOTMuMDkwOTA5WiIgZmlsbD0iI0Y2QUQwMCIgcC1pZD0iMzUyMiI+PC9wYXRoPjxwYXRoIGQ9Ik0yNDcuMTIxNDU1IDcwOS40NTc0NTVsMTAxLjc4MzI3Mi0xNDkuNjA4NzI4YTE1LjgyNTQ1NSAxNS44MjU0NTUgMCAwIDEgMjQuMTkyLTIuMzg1NDU0bDY3LjI1ODE4MiA2NS45MDgzNjMgMTQ3LjU5NTYzNi0yMzEuMzMwOTA5YTE1LjgyNTQ1NSAxNS44MjU0NTUgMCAwIDEgMjcuMDY2MTgyIDAuNjA1MDkxbDE4My4zODkwOTEgMzE3LjgxMjM2NGExNS44MjU0NTUgMTUuODI1NDU1IDAgMCAxLTEzLjcxOTI3MyAyMy43MzgxODJIMjYwLjIyNEExNS44MjU0NTUgMTUuODI1NDU1IDAgMCAxIDI0Ny4xMjE0NTUgNzA5LjQ2OTA5MXoiIGZpbGw9IiNGRkY3RjciIHAtaWQ9IjM1MjMiPjwvcGF0aD48cGF0aCBkPSJNMzU3LjM5OTI3MyAzNzAuNjk5NjM2bS03OS43OTA1NDYgMGE3OS43OTA1NDUgNzkuNzkwNTQ1IDAgMSAwIDE1OS41ODEwOTEgMCA3OS43OTA1NDUgNzkuNzkwNTQ1IDAgMSAwLTE1OS41ODEwOTEgMFoiIGZpbGw9IiNGRkZGRkYiIHAtaWQ9IjM1MjQiPjwvcGF0aD48L3N2Zz4=">
              <a class="c-primary right-space" :href="form.coverUrl" target="_blank">封面文件</a>
              <i class="el-icon-close click" @click="handleUploadCoverImageRemove"></i>
              <div v-if="form.coverUrl" class="image-wrapper">
                <img :src="form.coverUrl | ossImageProcess">
              </div>
            </template>
            <template v-else>
              <upload
                :fileType="COURSEWARE_FILE_TYPE_ENUM.IMAGE.value"
                @onStart="handleUploadCoverImageStart"
                @onSuccess="handleUploadCoverImageSuccess"
                @onRemove="handleUploadCoverImageRemove"
              />
              <div v-if="form.coverUrl" class="image-wrapper">
                <img :src="form.coverUrl | ossImageProcess">
              </div>
            </template>
          </el-col>
        </el-form-item>
        <el-form-item prop="coverUrlEn" v-if="form.type===COURSEWARE_FILE_TYPE_ENUM.VIDEO.value">
          <template slot="label">
            视频封面（英文） <span class="image-upload-tip">(推荐尺寸为750×320像素,支持jpg、jpeg、png格式)</span>
          </template>
          <el-col :span="12">
            <template v-if="isEdit && form.coverUrlEn">
              <img width="14" class="right-space" src="data:image/svg+xml;base64,PHN2ZyB0PSIxNjY0NTA4OTk3NTg0IiBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjM1MjEiIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiI+PHBhdGggZD0iTTAgMG05My4wOTA5MDkgMGw4MzcuODE4MTgyIDBxOTMuMDkwOTA5IDAgOTMuMDkwOTA5IDkzLjA5MDkwOWwwIDgzNy44MTgxODJxMCA5My4wOTA5MDktOTMuMDkwOTA5IDkzLjA5MDkwOWwtODM3LjgxODE4MiAwcS05My4wOTA5MDkgMC05My4wOTA5MDktOTMuMDkwOTA5bDAtODM3LjgxODE4MnEwLTkzLjA5MDkwOSA5My4wOTA5MDktOTMuMDkwOTA5WiIgZmlsbD0iI0Y2QUQwMCIgcC1pZD0iMzUyMiI+PC9wYXRoPjxwYXRoIGQ9Ik0yNDcuMTIxNDU1IDcwOS40NTc0NTVsMTAxLjc4MzI3Mi0xNDkuNjA4NzI4YTE1LjgyNTQ1NSAxNS44MjU0NTUgMCAwIDEgMjQuMTkyLTIuMzg1NDU0bDY3LjI1ODE4MiA2NS45MDgzNjMgMTQ3LjU5NTYzNi0yMzEuMzMwOTA5YTE1LjgyNTQ1NSAxNS44MjU0NTUgMCAwIDEgMjcuMDY2MTgyIDAuNjA1MDkxbDE4My4zODkwOTEgMzE3LjgxMjM2NGExNS44MjU0NTUgMTUuODI1NDU1IDAgMCAxLTEzLjcxOTI3MyAyMy43MzgxODJIMjYwLjIyNEExNS44MjU0NTUgMTUuODI1NDU1IDAgMCAxIDI0Ny4xMjE0NTUgNzA5LjQ2OTA5MXoiIGZpbGw9IiNGRkY3RjciIHAtaWQ9IjM1MjMiPjwvcGF0aD48cGF0aCBkPSJNMzU3LjM5OTI3MyAzNzAuNjk5NjM2bS03OS43OTA1NDYgMGE3OS43OTA1NDUgNzkuNzkwNTQ1IDAgMSAwIDE1OS41ODEwOTEgMCA3OS43OTA1NDUgNzkuNzkwNTQ1IDAgMSAwLTE1OS41ODEwOTEgMFoiIGZpbGw9IiNGRkZGRkYiIHAtaWQ9IjM1MjQiPjwvcGF0aD48L3N2Zz4=">
              <a class="c-primary right-space" :href="form.coverUrlEn" target="_blank">封面文件</a>
              <i class="el-icon-close click" @click="handleUploadCoverImageRemoveEn"></i>
              <div v-if="form.coverUrlEn" class="image-wrapper">
                <img :src="form.coverUrlEn | ossImageProcess">
              </div>
            </template>
            <template v-else>
              <upload
                :fileType="COURSEWARE_FILE_TYPE_ENUM.IMAGE.value"
                @onStart="handleUploadCoverImageStartEn"
                @onSuccess="handleUploadCoverImageSuccessEn"
                @onRemove="handleUploadCoverImageRemoveEn"
              />
              <div v-if="form.coverUrlEn" class="image-wrapper">
                <img :src="form.coverUrlEn | ossImageProcess">
              </div>
            </template>
          </el-col>
        </el-form-item>

        <el-form-item label="PDF页数" prop="coursewareLength" v-if="form.type===COURSEWARE_FILE_TYPE_ENUM.PDF.value">
          <el-col :span="12">
            <template>
              <el-input-number disabled controls-position="right" v-model="form.coursewareLength" :step="1" :min="1" :controls="false" v-input-int></el-input-number><span class="time-unit">页</span>
            </template>
          </el-col>
        </el-form-item>
        <el-form-item label="PDF页数（英文）" prop="coursewareLengthEn" v-if="form.type===COURSEWARE_FILE_TYPE_ENUM.PDF.value">
          <el-col :span="12">
            <template>
              <el-input-number disabled controls-position="right" v-model="form.coursewareLengthEn" :step="1" :min="1" :controls="false" v-input-int></el-input-number><span class="time-unit">页</span>
            </template>
          </el-col>
        </el-form-item>

        <el-form-item label="课件建议学习时长" prop="coursewareTime">
          <el-col :span="12" class="flex">
            <template>
              <el-input-number size="small" controls-position="right" v-model="form.coursewareTimeDay" :step="1" :min="0" :controls="false" @blur="handleCoursewareTimeBlur" v-input-int></el-input-number><span class="time-unit"> 天 </span>
              <el-input-number size="small" controls-position="right" v-model="form.coursewareTimeHour" :step="1" :min="0"  :max="24*60" :controls="false" @blur="handleCoursewareTimeBlur" v-input-int></el-input-number><span class="time-unit">小时</span>
              <el-input-number size="small" controls-position="right" v-model="form.coursewareTimeMinute" :step="1" :min="0"  :max="59" :controls="false" @blur="handleCoursewareTimeBlur" v-input-int></el-input-number><span class="time-unit">分</span>
            </template>
          </el-col>
        </el-form-item>

        <el-form-item label="课件建议学习时长 （英文）" prop="coursewareTimeEn">
          <el-col :span="12" class="flex">
            <template>
              <el-input-number size="small" controls-position="right" v-model="form.coursewareTimeDayEn" :step="1" :min="0" :controls="false" @blur="handleCoursewareTimeBlurEn" v-input-int></el-input-number><span class="time-unit"> 天 </span>
              <el-input-number size="small" controls-position="right" v-model="form.coursewareTimeHourEn" :step="1" :min="0"  :max="24*60" :controls="false" @blur="handleCoursewareTimeBlurEn" v-input-int></el-input-number><span class="time-unit">小时</span>
              <el-input-number size="small" controls-position="right" v-model="form.coursewareTimeMinuteEn" :step="1" :min="0"  :max="59" :controls="false" @blur="handleCoursewareTimeBlurEn" v-input-int></el-input-number><span class="time-unit">分</span>
            </template>
          </el-col>
        </el-form-item>
        <div class="operation">
          <el-button @click="$router.go(-1)" size="medium">取消</el-button>
          <el-button type="primary" @click="handleSave" size="medium">保存</el-button>
        </div>
      </el-form>
    </basic-container>
  </div>
</template>

<script>
import { coursewareTypeOptions, coursewareTimeUnitOptions, coursewareFileTypeEnums as COURSEWARE_FILE_TYPE_ENUM, coursewareTimeUnitEnums as COURSEWARE_TIME_UNIT_ENUM } from '@/const/crud/app/course';
import { caculateCoursewareTime, convertTimeStructure, getPdfName } from './util/index';
import Upload from './components/Upload.vue';
import { addCourseware, editCourseware, getCoursewareById, addCoursewareFileTemp } from '@/api/app/course';
import { fetchCoursewareGroupList } from '@/api/app/course';
import uploadService from '@/common/common-logic/upload-service';
import * as util from '@/util/util';

export default {
  components: {
    Upload,
  },
  data() {
    return {
      coursewareTypeOptions,
      coursewareTimeUnitOptions,
      COURSEWARE_FILE_TYPE_ENUM,
      COURSEWARE_TIME_UNIT_ENUM,
      rules: {
        type: [
          { required: true, message: '请选择课件类型', trigger: 'blur' },
        ],
        name: [
          { required: true, message: '请填写课件名称', trigger: 'blur' },
        ],
        nameEn: [
          { required: true, message: '请填写课件名称（英文）', trigger: 'blur' },
        ],
        coursewareUrl: [
          { required: true, message: '请选择文件', trigger: 'blur' },
        ],
        coursewareUrlEn: [
          { required: true, message: '请选择文件（英文）', trigger: 'blur' },
        ],
        coursewareTime: [
          { required: true, message: '请填写课件建议学习时长', trigger: 'blur' },
        ],
        coursewareTimeEn: [
          { required: true, message: '请填写课件建议学习时长（英文）', trigger: 'blur' },
        ],
      },
      fileList: [],
      form: {
        name: '',
        nameEn: '',
        description: '',
        descriptionEn: '',
        type: COURSEWARE_FILE_TYPE_ENUM.VIDEO.value,
        coverUrl: '',
        coverUrlEn: '',
        coursewareUrl: '',
        coursewareUrlEn: '',
        coursewareGroupId: undefined,
        coursewareLength: undefined,
        coursewareLengthEn: undefined,
        coursewareTime: undefined,
        coursewareTimeEn: undefined,
        coursewareTimeUnit: 1,
        coursewareTimeDay: undefined,
        coursewareTimeHour: undefined,
        coursewareTimeMinute: undefined,
        coursewareTimeDayEn: undefined,
        coursewareTimeHourEn: undefined,
        coursewareTimeMinuteEn: undefined,
      },
      isRemoveUploadedCoursewareFile: false,
      isRemoveUploadedCoursewareFileEn: false,
      isRemoveUploadedCoverImage: false,
      isRemoveUploadedCoverImageEn: false,
      isEdit: false,
      id: "",
      coursewareGroups: [],
      isTypeSelectDisabled: false,
      uploadItem: {
        rawFile: undefined,
        percent: 0,
        speed: 0,
        status: '',
      },
      isShowSizeAndSpeecInfo: false,
      errorNotice: undefined,
      video: null,
      videoImages: [],
      videoEn: null,
      videoImagesEn: [],
      submitBtnClick: false,
    }
  },
  computed: {
    coursewareFileFormLabel() {
      switch(this.form.type) {
        case COURSEWARE_FILE_TYPE_ENUM.PDF.value:
            return 'PDF上传';
        case COURSEWARE_FILE_TYPE_ENUM.VIDEO.value:
            return '视频上传';
        default:
      }
    },
    coursewareFileFormLabelEn() {
      switch(this.form.type) {
        case COURSEWARE_FILE_TYPE_ENUM.PDF.value:
            return 'PDF上传（英文）';
        case COURSEWARE_FILE_TYPE_ENUM.VIDEO.value:
            return '视频上传（英文）';
        default:
      }
    },
  },
  async mounted() {
  },
  async created() {
    const res = await this.requestWrapper(fetchCoursewareGroupList);
    if (!res.ok) {
      this.$message.error('获取课件分组失败');
    } else {
      this.coursewareGroups = res.data;
    }

    this.isEdit = this.$route.path.includes('edit');
    this.id = this.$route.params.id;
    if (this.isEdit && !isNaN(this.id)) {
      this.initDetail();
    }
  },
  methods: {
    getPdfName,
    caculateCoursewareTime,
    initDetail() {
      getCoursewareById(this.id).then(response => {
        const courseware = response.data.data;
        this.form.name = courseware.name;
        this.form.nameEn = courseware.nameEn;
        this.form.description = courseware.description;
        this.form.descriptionEn = courseware.descriptionEn;
        this.form.type = courseware.type;
        this.isTypeSelectDisabled = true;
        this.form.coverUrl = courseware.coverUrl;
        this.form.coverUrlEn = courseware.coverUrlEn;
        this.form.coursewareUrl = courseware.coursewareUrl;
        this.form.coursewareUrlEn = courseware.coursewareUrlEn;
        this.form.fileId = courseware.fileId;
        this.form.fileIdEn = courseware.fileIdEn;
        if (courseware.coverUrl) {
          const image = { src: courseware.coverUrl };
          this.videoImages.push(image);
        }
        if (courseware.coverUrlEn) {
          const image = { src: courseware.coverUrlEn };
          this.videoImagesEn.push(image);
        }
        this.video = {
          url: courseware.coursewareUrl,
        }
        this.videoEn = {
          url: courseware.coursewareUrlEn,
        }
        this.form.coursewareGroupId = courseware.coursewareGroupId;
        this.form.coursewareLength = courseware.coursewareLength;
        this.form.coursewareLengthEn = courseware.coursewareLengthEn;
        this.form.coursewareTime = courseware.coursewareTime;
        this.form.coursewareTimeEn = courseware.coursewareTimeEn;
        const timeInfo = convertTimeStructure(courseware.coursewareTime);
        this.form.coursewareTimeDay = timeInfo.day;
        this.form.coursewareTimeHour = timeInfo.hour;
        this.form.coursewareTimeMinute = timeInfo.minute;
        const timeInfoEn = convertTimeStructure(courseware.coursewareTimeEn);
        this.form.coursewareTimeDayEn = timeInfoEn.day;
        this.form.coursewareTimeHourEn = timeInfoEn.hour;
        this.form.coursewareTimeMinuteEn = timeInfoEn.minute;
      })
    },
    handleTypeChange() {
      this.videoImages = [],
      this.form.coverUrl = '';
      this.form.coursewareUrl = '';
      this.form.coursewareLength = undefined;
      this.form.coursewareTime = undefined;
      this.form.coursewareTimeDay = undefined;
      this.form.coursewareTimeHour = undefined;
      this.form.coursewareTimeMinute = undefined;
      this.videoImagesEn = [],
      this.form.coverUrlEn = '';
      this.form.coursewareUrlEn = '';
      this.form.coursewareLengthEn = undefined;
      this.form.coursewareTimeEn = undefined;
      this.form.coursewareTimeDayEn = undefined;
      this.form.coursewareTimeHourEn = undefined;
      this.form.coursewareTimeMinuteEn = undefined;
      this.$refs.ruleForm.clearValidate();
    },
    // 课件
    handleUploadCoursewareFileStart() {
      this.isTypeSelectDisabled = true;
      this.$refs.ruleForm.clearValidate();
    },
    handleUploadCoursewareFileSuccess(data) {
      this.form.coursewareUrl = data.fileUrl;
      this.form.fileId = data.fileId;
      this.$refs.ruleForm.validateField('coursewareUrl');
      if (this.form.type === COURSEWARE_FILE_TYPE_ENUM.PDF.value) {
        this.form.coursewareLength = data.fileLength;
      } else if (this.form.type === COURSEWARE_FILE_TYPE_ENUM.VIDEO.value) {
        this.form.coursewareLength = data.fileLength;
        if (data.coverImage) {
          const image = { src: data.coverImage.src, file: data.coverImage.file, id: util.getUUid() }
          this.videoImages.push(image);
        }
        addCoursewareFileTemp({fileId: data.fileId}).then(response => {
          if (response.code !== 0) {
            this.$message.error(response.msg);
          }
        })
      }
    },
    handleUploadCoursewareFileRemove() {
      this.videoImages = [];
      this.isTypeSelectDisabled = false;
      this.form.coursewareUrl = '';
      this.form.coverUrl = '';
      this.form.coursewareLength = undefined;
      this.$refs.ruleForm.validateField('coursewareUrl');
    },
    // 课件 - En
    handleUploadCoursewareFileStartEn() {
      this.isTypeSelectDisabled = true;
      this.$refs.ruleForm.clearValidate();
    },
    handleUploadCoursewareFileSuccessEn(data) {
      this.form.coursewareUrlEn = data.fileUrl;
      this.form.fileIdEn = data.fileId;
      this.$refs.ruleForm.validateField('coursewareUrlEn');
      if (this.form.type === COURSEWARE_FILE_TYPE_ENUM.PDF.value) {
        this.form.coursewareLengthEn = data.fileLength;
      } else if (this.form.type === COURSEWARE_FILE_TYPE_ENUM.VIDEO.value) {
        this.form.coursewareLengthEn = data.fileLength;
        if (data.coverImage) {
          const image = { src: data.coverImage.src, file: data.coverImage.file, id: util.getUUid() }
          this.videoImagesEn.push(image);
        }        
        addCoursewareFileTemp({fileIdEn: data.fileId}).then(response => {
          if (response.code !== 0) {
            this.$message.error(response.msg);
          }
        })
      }
    },
    handleUploadCoursewareFileRemoveEn() {
      this.videoImagesEn = [];
      this.isTypeSelectDisabled = false;
      this.form.coursewareUrlEn = '';
      this.form.coverUrlEn = '';
      this.form.coursewareLengthEn = undefined;
      this.$refs.ruleForm.validateField('coursewareUrlEn');
    },
    // 封面
    handleUploadCoverImageStart() {
      this.$refs.ruleForm.clearValidate();
    },
    handleUploadCoverImageSuccess(data) {
      this.form.coverUrl = data.fileUrl;
    },
    handleUploadCoverImageRemove() {
      this.form.coverUrl = '';
    },
    // 封面 - En
    handleUploadCoverImageStartEn() {
      this.$refs.ruleForm.clearValidate();
    },
    handleUploadCoverImageSuccessEn(data) {
      this.form.coverUrlEn = data.fileUrl;
    },
    handleUploadCoverImageRemoveEn() {
      this.form.coverUrlEn = '';
    },
    // 推荐时长
    handleCoursewareTimeBlur(event) {
      this.form.coursewareTime = this.caculateCoursewareTime(this.form.coursewareTimeDay, this.form.coursewareTimeHour, this.form.coursewareTimeMinute);
    },
    handleCoursewareTimeBlurEn(event) {
      this.form.coursewareTimeEn = this.caculateCoursewareTime(this.form.coursewareTimeDayEn, this.form.coursewareTimeHourEn, this.form.coursewareTimeMinuteEn);
    },
    // 删除文件提示
    handleRemoveUploadedFile(callback) {
      this.$confirm(`您是否确定重新上传此文件?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(callback);
    },
    async checkVideoCover(images) {
      // 封面不存在， 取视频的截图作为封面
      console.log(this.form.coverUrl);
      if(!this.form.coverUrl) {
        let files = [];
        const videoImages = util.deepClone(images).filter(item => !item.url);
        if (videoImages.length > 0) {
          for (let i = 0; i < videoImages.length; i++) {
            const item = videoImages[i];
            if (item.file) {
              const key = await util.getFileKeyAsync(item.file, util.getOSSPostPath());
              files.push({
                id: item.id,
                file: item.file,
                key,
              });
            }
          }
          if (files.length > 0) {
            const uploadedUrls = await uploadService.uploadFiles(files);
            uploadedUrls.forEach(item => {
              const image = videoImages.find(image => image.id === item.id);
              image.src = item.fileUrl;
            });
          }
          this.form.coverUrl = videoImages[0].src;
        }
      }
    },
    async checkVideoCoverEn(images) {
      // 封面不存在， 取视频的截图作为封面
      console.log(this.form.coverUrlEn);
      if(!this.form.coverUrlEn) {
        let files = [];
        const videoImages = util.deepClone(images).filter(item => !item.url);
        if (videoImages.length > 0) {
          for (let i = 0; i < videoImages.length; i++) {
            const item = videoImages[i];
            if (item.file) {
              const key = await util.getFileKeyAsync(item.file, util.getOSSPostPath());
              files.push({
                id: item.id,
                file: item.file,
                key,
              });
            }
          }
          if (files.length > 0) {
            const uploadedUrls = await uploadService.uploadFiles(files);
            uploadedUrls.forEach(item => {
              const image = videoImages.find(image => image.id === item.id);
              image.src = item.fileUrl;
            });
          }
          this.form.coverUrlEn = videoImages[0].src;
        }
      }
    },
    async handleSave() {
      // 封面不存在， 取视频的截图作为封面
      if (this.form.type === COURSEWARE_FILE_TYPE_ENUM.VIDEO.value) {
        await this.checkVideoCover(this.videoImages);
        await this.checkVideoCoverEn(this.videoImagesEn);
      }
      this.$refs.ruleForm.validate((valid, result) => {
        if (valid) {
          const params = {...this.form}
          if (this.submitBtnClick) {
            return;
          }
          this.submitBtnClick = true;
          if (this.isEdit) {
            params.id = this.id;
            editCourseware(params).then(_response => {
              this.submitBtnClick = false;
              this.$router.push({
                path: `/app/course/courseware`,
              });

            })
          } else {
            addCourseware(params).then(_response => {
              this.submitBtnClick = false;
              this.$router.push({
                path: `/app/course/courseware`,
              });
            })
          }
        }
      });
    },
  },
  directives: {
    'input-int': {
      bind(el) {
        el.onkeypress = function(e) {
          return (/[\d]/.test(String.fromCharCode(e.keyCode || e.which))) || e.which === 8;
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.flex {
  display: flex;
}
.right-space {
  margin-right: 8px;
}
.time-unit {
  margin: 0 10px;
}
.time-unit-selector {
  width: 78px!important;
}
.operation {
  text-align: right
}
.click {
  cursor: pointer;
}
.image-wrapper {
  position: relative;
  img {
    width: 40%;
  }
}
.upload-info {
  font-size: 12px;
}
.content-image-add {
  padding: 0;
  width: 52px;
  height: 52px;
  background: #FFFFFF;
  border: 1px dashed rgba(#5383F3, 0.3);
  border-radius: 4px;
}
.content-cover-button {
  width: 52px;
  height: 52px;
  border: 1px dashed rgba(#5383F3, 0.3);
  border-radius: 4px;
}
.image-remove-icon {
  position: absolute;
  padding: 0;
  top: 0;
}
</style>
